"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Options {
    constructor(options = {}) {
        this._options = {};
        this._authorization = {};
        this._metadata = {};
        this._options = options;
    }
    merge(options) {
        const raw = options.toObject();
        const newOptions = Object.assign(Object.assign({}, this._options), raw);
        if (this._options.headers || raw.headers) {
            newOptions.headers = Object.assign(Object.assign({}, this._options.headers), raw.headers);
        }
        const result = new Options(newOptions);
        result.authorization(Object.assign(Object.assign({}, this._authorization), options.getAuthorization()));
        result.metadata(Object.assign(Object.assign({}, this._metadata), options.getMetadata()));
        return result;
    }
    set(options = {}) {
        const newOptions = Object.assign(Object.assign({}, this._options), options);
        if (this._options.headers) {
            newOptions.headers = this._options.headers;
        }
        if (this._options.body) {
            newOptions.headers = this._options.headers;
        }
        this._options = newOptions;
        return this;
    }
    authorization(options = { identity: true, optional: true }) {
        this._authorization = options;
        return this;
    }
    header(key, value) {
        if (!this._options.headers) {
            this._options.headers = {};
        }
        key = key.toLowerCase();
        if (this._options.headers[key]) {
            console.warn(`Can not set header "${key}" as "${value}" because is already defined as "${this._options.headers[key]}"`);
        }
        else {
            this._options.headers[key] = value;
        }
        return this;
    }
    headers(headers) {
        Object.keys(headers).forEach((key) => this.header(key.toLowerCase(), headers[key]));
        return this;
    }
    method(method) {
        this._options.method = method;
        return this;
    }
    getMethod() {
        return this._options.method || 'GET';
    }
    metadata(data) {
        this._metadata = Object.assign(Object.assign({}, this._metadata), data);
        return this;
    }
    getMetadata() {
        return this._metadata;
    }
    json(data) {
        this.header('content-type', 'application/json');
        this._options.body = JSON.stringify(data);
        return this;
    }
    getAuthorization() {
        return this._authorization;
    }
    toObject() {
        return this._options;
    }
}
exports.default = Options;
